<script lang="ts">
	import type { ConfigsEntity } from '$lib/api/restApi';

	export let configs: ConfigsEntity[];
</script>

<!--
Only supports Zendesk Web Widget (Classic), the addons/settings page do not allow different options
The settings page allows you to integrate multiple widgets, this only uses the first enabled widget
TODO: Add support for Zendesk Messaging, In the settings page: remove the option to integrate multiple and
add toggle between Classic and Messaging
-->

<svelte:head>
	<script
		id="ze-snippet"
		src="https://static.zdassets.com/ekr/snippet.js?key={configs[0].values.team_id}"
	>
	</script>
</svelte:head>
